import { createContext, useContext, useState } from 'react'

import { useDisclosure } from '@mantine/hooks'

const EmploymentDetailsDrawerContext = createContext(null)

const EmploymentDetailsDrawerContextProvider = ({ children }) => {
  const [opened, { open, close }] = useDisclosure(false)
  const [employmentExperienceId, setEmploymentExperienceId] = useState(null)

  // Simple approach: Only requires employment experience ID
  const handleOpen = (experienceId) => {
    setEmploymentExperienceId(experienceId)
    open()
  }

  return (
    <EmploymentDetailsDrawerContext.Provider
      value={{
        opened,
        close,
        handleOpen,
        employmentExperienceId,
      }}
    >
      {children}
    </EmploymentDetailsDrawerContext.Provider>
  )
}

export function useEmploymentDetailsDrawerContext() {
  return useContext(EmploymentDetailsDrawerContext)
}

export {
  EmploymentDetailsDrawerContext,
  EmploymentDetailsDrawerContextProvider,
}
